import React, {PropTypes, Component } from 'react';
import renderHTML from 'react-render-html';
import CityCredits from './CityCredits';
import moment from 'moment-timezone';
import {getCityBySlug} from "./cities/Cities";;

const DATE_FORMAT = "D MMMM YYYY [at] h:mm A z";

class CityPage extends Component {
  static propTypes = {
    citySlug: PropTypes.string.isRequired,
  };

  dateOrTBD(val, tz, format=DATE_FORMAT) {
    if(val === null) {
      return "TBD";
    } else {
      //console.log(`${val}`);
      return moment(val).tz(tz).format(format);
    }
  }

  textOrTBD(val) {
    return val === null ? "TBD" : val;
  }

  linkOrTBD(url) {
    return url === null ? "TBD" :
      (<a href={url}>EventBrite</a>);
  }

  buttonOrNull(url) {
    return url === null ? null :
      (<a href={url} className="btn-default btn2">Register Now!</a>)
  }

  render() {
    const city = getCityBySlug(this.props.citySlug);
    var offset = 1;
    return (
        <div className="global indent">
          <article className="col-lg-12 col-md-12 col-sm-12 bookstoreBox">
            <h2><span>{city.name}, {city.state}</span></h2>
          </article>
          <CityCredits citySlug={this.props.citySlug} hideName={true}/>
          <div className="container">
            <div className="row">
              <article className="col-lg-12 col-md-12 col-sm-12 history-box">
                <h2><span>Event Details</span></h2>
                <ul className="list6">
                  {this.startDateDetails(city, offset++)}
                  {this.startLocationDetails(city, offset++)}
                  {this.eventDetailSections(city, offset)}
                </ul>
              </article>

            </div>
          </div>
        </div>
        );
  }

  startLocationDetails(city, offset) {
    const body = (city.eventStartLocation === null) ?
        `Start Location To Be Determined. (We will update this space as soon as we know!)` :
        `Meet at <b>${city.eventStartLocation}</b>`;
    return this.section("start-location", offset, "Event Start Location", [body]);
  }

  startDateDetails(city, offset) {
    const body = (city.eventStartDateTime === null) ?
      `Start Time To Be Determined. (We will update this space as soon as we know!)` :
      `<b>DASH 9: ${city.name}</b> will start on <b>${this.dateOrTBD(city.eventStartDateTime, city.eventTimeZone)}</b>`;
    return this.section("start-time", offset, "Event Start Date", [body]);
  }

  eventDetailSections(city, offset) {
    return (city.sections == null) ? null :
        city.sections.map( (section, index) => {
          return this.section(section.slug, index+offset, section.header, section.body);
        });
  }

  section(key, index, header, linesOfBodyText) {
    const lines = linesOfBodyText.map(
        (line, i) => (<p key={i}>{renderHTML(line)}</p>)
    )
    return (
              <li key={key}>
                <div className="badge">{index}.</div>
                <div className="extra-wrap">
                  <h2>{header}</h2>
                  {lines}
                </div>
              </li>
          );
  }
}

export default CityPage;



// WEBPACK FOOTER //
// ./src/CityPage.js